import APIPrefecture from '@/xhr/xhr-prefecture'

const namespaced = true

const initialState = {
  prefectures: []
}

export const state = {...initialState}

const getters = {
  prefectures: state => state.prefectures
}

const mutations = {
  setPrefecture (state, data) {
    state.prefectures = data
  }
}

const actions = {
  async setPrefectureAction ({commit}) {
    await APIPrefecture.getPrefecture(
    ).then((_res) => {
      commit('setPrefecture', _res.data)
      return Promise.resolve(_res.data)
    }).catch((err) => {
      return Promise.reject(err.response)
    })
  }
}

// モジュールに登録されるオブジェクト
export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/prefectures.js